import React, { ChangeEvent } from 'react';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Queries from '@api/graphql/queries';
import Paths from '@root/utils/Path';
import { compose } from 'react-apollo';
import { withRouter, RouterProps } from 'react-router';
import { Orders_orders_data, adminProductList } from '@api/graphql/types';
import { Async } from 'react-select';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { ApolloQueryResult } from "apollo-client";

interface State {
    isLoading: boolean;
    product?: Orders_orders_data;
    id: string;
    ext_id: string;
    name: string;
}


class ProductSearchForm extends React.Component<{} & RouterProps & InjectedIntlProps, State> {

    public state = {
        isLoading: false,
        id: '',
        ext_id: '',
        name: '',
    };

    private loadOptions = (inputValue: string) => {
        return new Promise(resolve => {
            GraphQLClient.query<adminProductList>({
                query: Queries.adminProductList,
                variables: {
                    page: 1,
                    count: 10,
                    filters: {
                        name: inputValue,
                    },
                },
            }).then(options => {
                if (options.data.adminProducts && options.data.adminProducts.data) {
                    resolve(options.data.adminProducts.data.map((product) => {
                        return {value: JSON.stringify({id: product.id, ext_id: product.ext_id}), label: product.name};
                    }));
                }
            });
        });
    }

    private changeExtId = (e: ChangeEvent<HTMLInputElement>) => {
        const extId = e.currentTarget.value;
        this.setState({ext_id: extId, id: '', name: '', isLoading: true}, async () => {
            const response: ApolloQueryResult<adminProductList> = await GraphQLClient.query<adminProductList>({
                query: Queries.adminProductList,
                variables: {
                    page: 1,
                    count: 1,
                    filters: {
                        ext_id: this.state.ext_id,
                    },
                },
            });

            if (response.data && response.data.adminProducts && response.data.adminProducts.data && response.data.adminProducts.data[0]) {
                const product = response.data.adminProducts.data[0];
                this.setState({id: product.id, name: product.name, isLoading: false});
            } else {
                this.setState({name: '', id: '', isLoading: false});
            }
        });
    }


    public render() {
        // @ts-ignore
        const product = this.state.product;
        return (
            <form className="form-horizontal">
                <div className="form-group">
                    <label className="col-sm-4">{this.props.intl.formatMessage({id: 'module.dashboard.ext_id.title'})}</label>
                    <div className="col-sm-8">
                        <input type="text" value={this.state.ext_id} name="ext_id" placeholder={this.props.intl.formatMessage({id: 'module.dashboard.ext_id.title'})} className="form-control" onChange={this.changeExtId} />
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4">{this.props.intl.formatMessage({id: 'module.dashboard.name.title'})}</label>

                    <div className="col-sm-8">
                        <Async
                            loadOptions={this.loadOptions}
                            value={{value: JSON.stringify({id: this.state.id, ext_id: this.state.ext_id}), label: this.state.name}}
                            onChange={(value: {value: string, label: string}) => {
                                const { id, ext_id } = JSON.parse(value.value);
                                this.setState({id, ext_id, name: value.label});
                            }}
                        />
                    </div>
                </div>

                <div className="form-group">
                    <div className="col-sm-12">
                        <button
                            className="btn btn-primary btn-block"
                            disabled={!this.state.id || !this.state.name}
                            onClick={() => {
                                if (this.state.id && this.state.name) {
                                    this.props.history.push(`${Paths.product}/${this.state.id}`);
                                }
                            }}
                        >{this.state.isLoading ? this.props.intl.formatMessage({id: 'common.loading'}) : this.props.intl.formatMessage({id: 'common.open'})}</button>
                    </div>
                </div>
            </form>
        );
    }
}

export default compose(
    injectIntl,
    withRouter,
)(ProductSearchForm);



// WEBPACK FOOTER //
// ./src/modules/Dashboard/components/ProductSearchForm.tsx